export const MIXPANEL_TOKEN = "2ef794ab57b1ebe9eae30b95a0532580";
export const GD_URL = "https://getdiamondsserver.cyberfuze.com";
export const GD_CLIENT_URL = "https://www.get-diamonds.com";
export const API_URL = "https://server.tradediamonds.com/api";
export const TENDERS_CLIENT = "https://tradediamonds.com";
export const isLocal = false;
